import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { StoreUserService } from '@app/core/state/store-user.service';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { lastValueFrom } from 'rxjs';

import { DialogDocument } from '../../data/models/dialog.model';

@Injectable({
  providedIn: 'root'
})
// @Injectable()
export class CreateDialogService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {}

  async createDialog(dialogPostBody): Promise<DialogDocument> {
    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    var result = await lastValueFrom(
      this.httpClient.post<DialogDocument>(
        `${apiConfig.uri}/licence/${sectionId}/dialog`,
        dialogPostBody,
        {
          headers: this.headers
        }
      )
    );
    return result;
  }
}
